// Client labels only: the stored width, height, format ID and crop never change.
export function formatPresentation(value) {
  const nested = value?.book_format;
  const source = nested && typeof nested === "object" ? nested : (value?.bookData || value);
  let width = Number(source?.width_mm ?? source?.widthMm ?? source?.book_width_mm);
  let height = Number(source?.height_mm ?? source?.heightMm ?? source?.book_height_mm);
  // Old cached cart entries sometimes contain only the human-readable size.
  if (!(width > 0 && height > 0)) {
    const saved = String(value?.size || "").match(/^\s*(\d+(?:[.,]\d+)?)\s*[×xх]\s*(\d+(?:[.,]\d+)?)\s*(?:мм)?\s*$/i);
    if (saved) {
      width = Number(saved[1].replace(",", "."));
      height = Number(saved[2].replace(",", "."));
    }
  }
  if (height === 210 && [155, 160].includes(width)) {
    return { code: "A5", title: "Маленький формат", size: "160×210 мм" };
  }
  if (width === 195 && height === 250) {
    return { code: "A4", title: "Большой формат", size: "195×250 мм" };
  }
  const size = Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0
    ? `${width}×${height} мм` : "";
  return { code: null, title: source?.display_title || source?.book_format_title || source?.title || "Фотокнига", size };
}

export function clientFormatName(value) {
  return formatPresentation(value).title;
}

export function clientFormatSize(value) {
  return formatPresentation(value).size || "Размер не указан";
}

export function bookFormatLabel(value) {
  const spec = formatPresentation(value);
  if (spec.code) return `${spec.title} · ${spec.size}`;
  return spec.size || value?.format_label || value?.size || "Формат не определён";
}